import { createSelector } from 'reselect';
import { DOMAIN_NAME } from './common';

const menuStateSelector = (state) => state[DOMAIN_NAME];

export const menusSelector = createSelector(
    menuStateSelector,
    (state) => state.menus
);

export const permissionsSelector = createSelector(
    menuStateSelector,
    (state) => state.permissions
);

export const selectedMenuSelector = createSelector(
    menuStateSelector,
    (state) => state.selectedMenu
);

export const loadingSelector = createSelector(
    menuStateSelector,
    (state) => state.loading
);

export const permissionsLoadingSelector = createSelector(
    menuStateSelector,
    (state) => state.permissionsLoading
);

export const errorSelector = createSelector(
    menuStateSelector,
    (state) => state.error
);

export const totalSelector = createSelector(
    menuStateSelector,
    (state) => state.total
);

export const isMenuDialogOpenSelector = createSelector(
    menuStateSelector,
    (state) => state.isMenuDialogOpen
);

export const isDeleteDialogOpenSelector = createSelector(
    menuStateSelector,
    (state) => state.isDeleteDialogOpen
);

export const menuToDeleteSelector = createSelector(
    menuStateSelector,
    (state) => state.menuToDelete
);
